import areIntlLocalesSupported from 'intl-locales-supported';

let DateTimeFormat;

/**
 * Create custom DateTimeFormat.
 * Fallback for non modern browser with the intl polyfill package
 */
if (areIntlLocalesSupported(['fr', 'fa-IR'])) {
    DateTimeFormat = global.Intl.DateTimeFormat;
} else {
    const IntlPolyfill = require('intl');
    DateTimeFormat = IntlPolyfill.DateTimeFormat;
    require('intl/locale-data/jsonp/fr');
    require('intl/locale-data/jsonp/fa-IR');
}

export default DateTimeFormat;


// WEBPACK FOOTER //
// ./src/utils/DateTimeFormat.js